const Config = {
  Provider: {
    unknown: 'unknown',
    email: 'email',
    linkedin: 'linkedin',
    github: 'github',
    googleScholar: 'google-scholar',
  }
};

function detectProvider(url) {
  const { protocol, hostname } = url;

  if (protocol === 'mailto:') {
    return Config.Provider.email;
  }

  const cleanHostname = hostname.replace(/^www\./, "").toLowerCase();

  if (cleanHostname.endsWith('scholar.google.com')) {
    return Config.Provider.googleScholar;
  }

  if (cleanHostname.endsWith('linkedin.com')) {
    return Config.Provider.linkedin;
  }

  if (cleanHostname.endsWith('github.com') || cleanHostname.endsWith('github.io')) {
    return Config.Provider.github;
  }

  return Config.Provider.unknown;
}

export function convertToLinkObject(value) {
  let result = null;

  try {
    const string = new String(value || '').trim();
    if (!string) {
      throw new Error('Invalid value; Empty string detected');
    }

    let url = new URL(string);
    return { ...url, provider: detectProvider(url), rawURL: value }
  } catch (e) {
    result = null;
  }

  return result;
}
